import { Component, Vue, Watch } from 'vue-property-decorator';
import { PropOptions } from 'vue';
import { IADField } from '@/shared/model/ad-field.model';

const AdInputTextProps = Vue.extend({
  props: {
    disabled: Boolean,
    fieldMeta: Object,

    rows: <PropOptions>{
      type: Number,
      default: () => {
        return 1;
      },
    },

    value: String,
  },
});

@Component
export default class AdInputText extends AdInputTextProps {
  text: string = null;

  get maxLength() {
    const meta = this.fieldMeta as IADField;
    const overrideColumn = meta.maxValue !== void 0 && meta.maxValue !== null;
    const max = overrideColumn ? meta.maxValue : meta.adColumn?.maxValue;
    return max === void 0 || max === null ? Infinity : max;
  }

  get minLength() {
    const meta = this.fieldMeta as IADField;
    const overrideColumn = meta.minLength !== void 0 && meta.minLength !== null;
    const min = overrideColumn ? meta.minLength : meta.adColumn?.minLength;
    return min === void 0 || min === null ? Infinity : min;
  }

  get type() {
    return this.rows > 1 ? 'textarea' : 'text';
  }

  @Watch('value')
  onValueChanged(value: string) {
    this.text = value;
  }

  onChanged(value: string) {
    this.$emit('change', value);
  }

  onInput(value: string) {
    this.$emit('input', value);
  }

  created() {
    this.text = this.value;
  }
}
